import { observable } from 'mobx';

class CommonStore {
  @observable version = 'commonStore-1.0.0';
}
export default { name: 'commonStore', Store: CommonStore };
